// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__7GYoD","top":"styles_top__2ei2b"};